import * as Sentry from '@sentry/ember';

/**
 * This method captures a GraphQL error and sends it to Sentry.
 * Importantly, it groups errors together based on the GraphQL error response
 * using a fingerprint so that we can distinguish between different types of
 * errors that the service returns.
 *
 * @see https://docs.sentry.io/platforms/javascript/guides/ember/usage/
 * @see https://docs.sentry.io/platforms/javascript/guides/ember/enriching-events/
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function captureGraphqlError(reason: any) {
  const error = reason?.graphQLErrors?.[0];
  if (!error) {
    console.error(reason);
    return;
  }

  const { extensions } = error;
  Sentry.withScope(function (scope) {
    // group errors together based on the GraphQL error response
    scope.setFingerprint([
      extensions?.status,
      extensions?.code,
      error?.message,
      (error?.path ?? []).join(':'),
    ]);
    Sentry.captureException(
      new Error(extensions?.title || reason.message, {
        cause: reason,
      }),
    );
  });
}
